import { render, staticRenderFns } from "./templateSelect.vue?vue&type=template&id=0a8b105d&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./templateSelect.vue?vue&type=style&index=0&id=0a8b105d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8b105d",
  null
  
)

export default component.exports